// @flow

import { RECEIVED_SITE_SETTINGS } from './constants';
import type { ReceivedSiteSettings } from './actions';

const initialState = {
  my_label: '',
  my_url: '',
  gtm_code: '',
  cookie_notification: '',
  google_site_verification: '',
  main_menu_more_label: '',
  scripts: [],
  logo: (null: ?string),
  favicons: null,
  vbmr_enabled: false,
  show_thuiswinkel_logo: true,
  touch_menu_button_text: '',
  touch_menu_title_text: '',
  touch_menu_back_button_text: '',
};

export type State = typeof initialState;

const siteSettings = (state: State = initialState, action: ReceivedSiteSettings): State => {
  switch (action.type) {
    case RECEIVED_SITE_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default siteSettings;
